import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CompanyNavbar from 'components/Navbars/CompanyNavbar'
import MemberList from 'components/Lists/MemberList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { SubContainer, SubTitle, InfoText } from '../styles'

export default function Members () {
  const [loading, setLoading] = useState (true)
  const [query, setQuery] = useState ('')
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [members, setMembers] = useState ([])
  const company = AuthService.getUser ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getMembers (query, 1)
  }, [query])

  const getMembers = async (nameQuery = query, pageNumber = page) => {
    if (lastPage && pageNumber > lastPage) return

    try {
      if (pageNumber === 1) setLoading (true)

      let filters = `company_id=${company.id}&page=${pageNumber}&query=${encodeURIComponent (nameQuery)}`

      const { data: membersResponse } = await cutileiApi.get (`/members?${filters}`, requestConfig)
      const { data, meta } = membersResponse
      const membersData = pageNumber > 1 ? [...members, ...data] : data

      setMembers (membersData)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }


  return (
    <SubContainer>
      <CompanyNavbar/>
      {members.length === 0 && !loading && (
        <>
          <SubTitle>
            Sua empresa ainda não possui colaboradores cadastrados na Cutilei
          </SubTitle>
          <InfoText>
            Assine um de nossos planos para seus colaboradores
          </InfoText>
        </>
      )}
      {loading ? <Loading/> : (
        <MemberList
          members={members}
          hasMore={!(lastPage && page > lastPage)}
          onUpdate={member => setMembers (members.map (m => m.id === member.id ? member : m))}
          onScroll={getMembers}
        />
      )}
    </SubContainer>
  )
}
